module.exports = __webpack_public_path__ + "9e16c946b716309e2286f61c1d9aa070.png";